import React from 'react';
import Container from 'react-bootstrap/Container';
import { t } from '../../../../i18n';
import { ratingStarFullIcon, ratingStarHalfIcon } from '../assets';
import './styles.scss';

const GiftCardStarRating = () => {
  return (
    <Container className="gift-card-star-rating">
      <p className="gift-card-star-rating__title">{t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.WHATS_RATING')}</p>
      <div className="gift-card-star-rating__rate" title="4,6/5">
        <img src={ratingStarFullIcon} alt="Star" />
        <img src={ratingStarFullIcon} alt="Star" />
        <img src={ratingStarFullIcon} alt="Star" />
        <img src={ratingStarFullIcon} alt="Star" />
        <img src={ratingStarHalfIcon} alt="Half-star" />
        <span className="gift-card-star-rating__text-rating">4,6/5</span>
      </div>
    </Container>
  );
};

export default GiftCardStarRating;
